import { render, staticRenderFns } from "./MultiSelectLearning.vue?vue&type=template&id=38b41630&scoped=true&"
import script from "./MultiSelectLearning.vue?vue&type=script&lang=js&"
export * from "./MultiSelectLearning.vue?vue&type=script&lang=js&"
import style0 from "./MultiSelectLearning.vue?vue&type=style&index=0&id=38b41630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b41630",
  null
  
)

export default component.exports